import { useRef, type ReactNode } from 'react';
import Navbar from '../../pages/home/components/Navbar';
import Footer from '../../pages/home/components/Footer';
import { useReveal } from '../../hooks/useReveal';
import { pageSeo } from '../../content/seo';
import { Seo } from '../Seo';

/**
 * Tasarımı kendi hero'suyla gelen alt sayfaların iskeleti (çözüm ve ürün
 * sayfaları). PageShell'den farkı kırılım şeridi yok: sayfa yolunu hero'daki
 * rozet gösterir. `.zh-reveal` öğeleri kaydırınca açılır.
 *
 * `pageKey` sayfanın adresidir: başlık/açıklama/canonical etiketleri (`Seo`) buradan `content/seo.ts`
 * kaydıyla bulunur; sayfalar ayrıca çizmez. Kayıtta olmayan adres etiketsiz kalır (kayıt eksik demektir).
 */
export function SubpageShell({ pageKey, children }: { pageKey: string; children: ReactNode }) {
  const rootRef = useRef<HTMLDivElement>(null);
  useReveal(rootRef, pageKey);
  const seo = pageSeo(pageKey);

  return (
    <div ref={rootRef} className="flex min-h-screen flex-col overflow-x-clip bg-surface">
      {seo && <Seo {...seo} />}
      <Navbar />
      <main className="flex-1 pt-nav">{children}</main>
      <Footer />
    </div>
  );
}
